import React from "react"
import { styled } from "@mui/material"
import { useTranslations } from "@cirrus/core/i18n/provider"

export const Separator = () => {
  const { i18n } = useTranslations()
  return <Container><Line/><Text>{i18n("General:Or").toUpperCase()}</Text><Line/></Container>
}

const Container = styled("div")({
  display: "flex", alignItems: "center", justifyContent: "center", columnGap: "7px",
})

const Line = styled("div")(({ theme: { typography: { pxToRem } } }) => ({
  width: pxToRem(100), height: "1px", background: "#79747E",
}))

const Text = styled("span")({
  fontSize: "14px", fontWeight: 600, lineHeight: "10px", letterSpacing: 0,
})